import { useState } from "react";
import { FoiItem } from "../../domain/FoiItem";
import { EntityDialog, DialogType } from "./types";
import { buildDefinitions } from "./buildDefinitions";
import { ActivityFeed } from "@ofqual/portal-activity-feed";
import { RenderDialog } from "./RenderDialog";
import { useAuth, useLookup } from "@ofqual/portal-core/core/hooks";
import {
  caseTypeSlaService,
  citizenResponseTypeService,
  foiEventTypeService,
  formalResponseTypeService,
} from "../../services";
import { authSelector } from "../../redux/selectors";
import { UserType } from "../../redux/types";

type FoiActivityFeedProps = {
  foiItem: FoiItem;
};

export const FoiActivityFeed: React.FC<FoiActivityFeedProps> = ({
  foiItem,
}) => {
  const [focusedEntity, setFocusedEntity] = useState<EntityDialog | null>(null);

  const { userType } = useAuth(authSelector);

  const canEdit = userType === UserType.Ofqual;
  const canRecordCompletion = canEdit; //FIX!

  const [
    caseTypeSlaLookups,
    foiEventTypeLookups,
    citizenResponseTypeLookups,
    formalResponseTypeLookups,
  ] = useLookup(
    caseTypeSlaService,
    foiEventTypeService,
    citizenResponseTypeService,
    formalResponseTypeService
  );

  const definitions = buildDefinitions(
    (activity, dialogType) => {
      setFocusedEntity({
        dialogType: dialogType || DialogType.ActivityAction,
        focusedActivity: activity,
      });
    },
    foiItem,
    canRecordCompletion,
    caseTypeSlaLookups,
    foiEventTypeLookups,
    citizenResponseTypeLookups,
    formalResponseTypeLookups
  );

  const defaultActions = [
    {
      label: "Add Note",
      dataTest: "add-note-button",
      action: () =>
        setFocusedEntity({
          dialogType: DialogType.AddNote,
        }),
      disabled: !!foiItem.closedByUpn,
    },
    {
      label: "Internal Message",
      dataTest: "internal-message-button",
      action: () =>
        setFocusedEntity({
          dialogType: DialogType.AddInternalMessage,
        }),
      disabled: !!foiItem.closedByUpn,
    },
    {
      label: "Contact Citizen",
      dataTest: "contact-citizen-button",
      action: () =>
        setFocusedEntity({
          dialogType: DialogType.SendPublicMessage,
        }),
      disabled: !!foiItem.closedByUpn,
    },
    {
      label: "Add event",
      // disabled: !canCreateEvent,
      disabled: false,
      dataTest: "add-event-button",
      action: () =>
        setFocusedEntity({
          dialogType: DialogType.AddEvent,
        }),
    },
  ];

  const allowedActions = canEdit ? defaultActions : [];

  return (
    <>
      <ActivityFeed
        resourceId={foiItem.id.toString()}
        specialSegmentLabel={(activity) =>
          activity.activityType === 35 ? "Events" : null
        }
        definitions={definitions}
        actions={allowedActions}
      />
      {canEdit && (
        <RenderDialog
          focusedEntity={focusedEntity}
          onClose={() => setFocusedEntity(null)}
          foiItem={foiItem}
        />
      )}
    </>
  );
};
